import PleaseWaitOverlay from 'components/PleaseWaitOverlay';
import { useStatusContext } from 'pages/Status/context';

import { INTRODUCED_TITLE, TITLE } from './constants';

const LenderReview: React.FunctionComponent = function () {
  const { isIntroduced, isDeliveryOnly } = useStatusContext();
  return (
    <PleaseWaitOverlay
      icon="check-circle-color"
      iconClassName="text-red-200 mb-4"
      title={isIntroduced || isDeliveryOnly ? INTRODUCED_TITLE : TITLE}
      labelLine1="Ideal4Finance's team will call you within the next 24 hours. We'll aim to call between 2pm-4pm. The lender, Propensio, will also be reaching out to perform their welcome call. They will aim to call anytime between 9am-6pm the next working day, on the number 01709 808990"
    />
  );
};

export default LenderReview;
